const APIStates = {
  INITIAL: 'INITIAL',
  PENDING: 'PENDING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
  ERROR_400: 'ERROR_400',
  ERROR_404: 'ERROR_404',
  ERROR_401: 'ERROR_401',
  ERROR_403: 'ERROR_403',
  ERROR_429: 'ERROR_429',
};

export default APIStates;
